<div class="row-header" [ngClass]="{'row-header--pop-up': isChild}">
  <span class="row-header__text" translate="account.title.add-demo"></span>
</div>

<div class="form-field b-style add-demo-widget" [ngClass]="{'add-demo-widget--pop-up': isChild}">
  <form (ngSubmit)="addFunds()" [formGroup]="form" novalidate>
    @if ({ focus: false, control: form.get('amount'), field: 'amount' }; as ctx) {
      <app-form-field type="custom" class="add-demo-widget__input-box form-field form-field--no-margin"
        [isControlTouched]="ctx.control.touched" [errors]="ctx.control.errors"
        [errorTexts]="fieldErrors(ctx.field)"
        [submitErrors]="submitErrors.asObservable()"
        [reset]="resetForm.asObservable()"
        >
        <label [for]="ctx.field" [class.fade-in]="ctx.control.value || ctx.focus" translate="account.label.amount"></label>
        <input type="text" inputmode="decimal" name="amount" autocomplete="off" [id]="ctx.field"
          [maskito]="maskOptions"
          [formControlName]="ctx.field"
          (focus)="ctx.focus = true"
          (blur)="ctx.focus = false"
          [placeholder]="'account.label.amount' | translate">
      </app-form-field>
      <div class="actions-wrapper">
        <button type="submit" class="button button--wide" [disabled]="ctx.control.errors">
          <div class="button__wrapper">
            <i class="fas fa-cog fa-spin" [hidden]="!isLoading">
              <div class="preloader">
                <div class="preloader__dot"></div>
                <div class="preloader__dot preloader__dot--2"></div>
                <div class="preloader__dot preloader__dot--3"></div>
              </div>
            </i>
            <span [style.visibility]="isLoading ? 'hidden' : 'visible'" translate="account.button.confirm"></span>
          </div>
        </button>
      </div>
    }
  </form>
</div>
